/* eslint-disable no-debugger */
import { Fragment, useState } from "react";

import useMeetSanctionInfoFormV2 from "./UseMeetSanctionInfoFormV2";

import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";
import DatePicker from "@usas/ui-web/components/datepickers/DatePicker";
import Input from "@usas/ui-web/components/inputs/Input";
import MeetClassificationTreeView from "@usas/ui-web/components/tree/meetClassificationTree/MeetClassificationTreeView";
import CourseMultiSelect from "@usas/ui-web/components/multiSelect/courseMultiSelect/CourseMultiSelect";
import MeetSoftwareDropdown from "@usas/ui-web/components/dropdowns/meetSoftwareDropdown/MeetSoftwareDropdown";
import Dropdown from "@usas/ui-web/components/dropdowns/Dropdown";
import ReadOnly from "@usas/ui-web/components/readOnly/ReadOnly";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import Headings from "@usas/ui-web/components/headings/Headings";

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import Constants from "@usas/ui-web/utils/Constants";
import YesNoSwitch from "@usas/ui-web/components/yesNoSwitch/YesNoSwitch";

import style from './MeetSanctionForm.module.css';

const MeetSanctionInfoFormV2 = ({
  savedFormState,
  clubFacilities,
  orgUnitId,
  onSubmitFormCallback,
  onCancelClicked,
  state,
  setState,
  meetState,
  selectedMeetClassificationId,
  selectedMeetClassificationName,
  hasUsasSanctionAccess
}) => {
  const {
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged,
    onValueTextPairChanged,
    onUploadTemplateClicked,
    removeFileModalState,
    onOpenRemoveFileModalClicked,
    onRemoveTemplateClicked,
    onRemoveFileModalCanceled,
    meetFileUploadState,
    meetFormatState,
    modalState,
    meetSanctionConfigurationState,
    onDownloadUploadedFile,
    onModalCancelClicked,
    USAS_SANCTION_TEXT,
    LSC_SANCTION_TEXT
  } = useMeetSanctionInfoFormV2(
    savedFormState,
    onSubmitFormCallback,
    state,
    setState,
    selectedMeetClassificationId,
    selectedMeetClassificationName,
    meetState,
    hasUsasSanctionAccess);

  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Fragment>
      <form onSubmit={handleSubmit} noValidate>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <Headings.H6>Meet Announcement (Optional)</Headings.H6>
          </div>
          <div className="col-xs-12">
            {formState.meetAnnouncementUrl === '' || formState.meetAnnouncementFileName.includes("Bad Request") ?
              <Fragment>
                <label htmlFor="announcement-file-upload" className={global.FileUpload}>
                  Upload File
                </label>
                <input hidden id="announcement-file-upload" type="file" onChange={onUploadTemplateClicked} />
                &nbsp;(*.pdf), (*.doc), or (*.docx)
              </Fragment>
              :
              <Fragment>
                <SecondaryButton onClick={onOpenRemoveFileModalClicked}>Remove Uploaded File</SecondaryButton>&nbsp;
                <PrimaryButton type="button" onClick={(e) => { onDownloadUploadedFile(e) }}>Download Uploaded File</PrimaryButton>
              </Fragment>}
          </div>
          {formState.meetAnnouncementFileName.includes("Bad Request") === false && formState.meetAnnouncementFileName !== '' &&
            <div className="usas-extra-bottom-margin">
              <div className="col-xs-12">
                <p><b>Uploaded File Name:</b> {formState.meetAnnouncementFileName}</p>
              </div>
            </div>
          }
          {formState.meetAnnouncementFileName.includes("Bad Request") === true &&
            <div className="col-xs-12">
              <p className={global.ErrorMessage} style={{ fontSize: 16, fontWeight: 'bold' }}>Invalid File Type</p>
            </div>
          }
          {state.error &&
            <div className="col-xs-12">
              <p className={global.ErrorMessage}>{state?.error ? state?.error : ''}</p>
            </div>
          }
          <div className="col-xs-12 usas-extra-top-margin"></div>
        </div>
        {/* <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <YesNoSwitch
              label="Sanction meet through USA Swimming?"
              name="isUsasSanctionMeet"
              checked={formState.isUsasSanctionMeet}
              error={errorState.isUsasSanctionMeet}
              message={errorState.isUsasSanctionMeet}
              value={formState.isUsasSanctionMeet}
              onChange={(value) => { onFormValueChanged('isUsasSanctionMeet', value); }} />
            <span style={{ color: '#202020', fontStyle: 'italic', gridColumn: '1 / -1' }}>
              {formState.isUsasSanctionMeet ? USAS_SANCTION_TEXT : LSC_SANCTION_TEXT}
            </span>
          </div>
        </div> */}
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="Year for Meet Name"
              name="autogeneratedMeetYear"
              value={formState.autogeneratedMeetYear}
            />
          </div>
          {/* <div className="col-xs-12 col-sm-6 col-md-4">
            <ReadOnly
              label="LSC for Meet Name"
              name="autogeneratedMeetLsc"
              value={formState.autogeneratedMeetLsc}
            />
          </div> */}
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Meet Name* (Do not include Year or LSC)"
              name="meetName"
              value={formState.meetName}
              error={errorState.meetName}
              message={errorState.meetName}
              onChange={(value) => { onFormValueChanged('meetName', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <DatePicker label="Start Date*"
              name="startDate"
              value={formState.startDate}
              error={errorState.startDate}
              message={errorState.startDate}
              onChange={(value) => {
                onFormValueChanged('startDate', value);
                onFormValueChanged('autogeneratedMeetYear', value.toString().substring(6, 10) !== '0000' ? value.toString().substring(6, 10) : '')
              }}
              countOfYears={5}
              startYearOffset={0} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <DatePicker label="End Date*"
              name="endDate"
              value={formState.endDate}
              error={errorState.endDate}
              message={errorState.endDate}
              onChange={(value) => { onFormValueChanged('endDate', value); }}
              countOfYears={5}
              startYearOffset={0} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <MeetClassificationTreeView
              label="Meet Classification*"
              name="meetClassification"
              value={formState.meetClassification}
              error={errorState.meetClassification}
              message={errorState.meetClassification}
              selectableLeavesOnly={true}
              singleSelect={true}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'meetClassification', newValueLabel, 'meetClassificationName', e); }}
              orgUnitId={orgUnitId || ''}
              filterId={-1}
              filterMode={"exclude_filter_id"}
            />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Dropdown
              label="Facility*"
              name="facilityId"
              value={formState.facilityId}
              error={errorState.facilityId}
              message={errorState.facilityId}
              options={clubFacilities}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'facilityId', newValueLabel, 'facilityName', e); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <CourseMultiSelect
              label="Meet Course(s)*"
              name="meetCourse"
              value={formState.meetCourse}
              error={errorState.meetCourse}
              message={errorState.meetCourse}
              onChange={(value) => { onFormValueChanged('meetCourse', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <MeetSoftwareDropdown
              label="Meet Management Software*"
              name="meetSoftwareId"
              value={formState.meetSoftwareId}
              error={errorState.meetSoftwareId}
              message={errorState.meetSoftwareId}
              onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'meetSoftwareId', newValueLabel, 'meetSoftwareName', e); }} />
          </div>
          {meetFormatState.isArrayLoaded &&
            <div className="col-xs-12 col-sm-6 col-md-4">
              <Dropdown
                label="Meet Format"
                name="meetFormatId"
                value={formState.meetFormatId}
                error={errorState.meetFormatId}
                message={errorState.meetFormatId}
                options={meetFormatState.options}
                isLoading={meetFormatState.isArrayLoading}
                onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'meetFormatId', newValueLabel, 'meetFormatName', e); }} />
            </div>
          }
        </div>
        {/* {formState.isUsasSanctionMeet === true && */}
        {/* <> */}
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            <Input
              label="Description of Medical Supervision*"
              name="descriptionOfMedicalSupervision"
              value={formState.descriptionOfMedicalSupervision}
              error={errorState.descriptionOfMedicalSupervision}
              message={errorState.descriptionOfMedicalSupervision}
              onChange={(value) => { onFormValueChanged('descriptionOfMedicalSupervision', value); }} />
          </div>
        </div>
        <div className="row" style={{ fontStyle: 'italic', color: '#6c6c6c', paddingLeft: '14px' }}>
          A description of the medical supervision (e.g., lifeguards, EMT, AED device, etc.) available to athletes participating in the meet. 
        </div>
        <div className={`row usas-extra-top-margin ${style.container}`}>
          <div className={style.header} onClick={toggleExpansion}>
            <span>{isExpanded ? '▲ Collapse' : '▼ Expand'}</span>
          </div>
          <div className={`${style.content} ${isExpanded ? style.expanded : style.collapsed}`}>
            <div className={`${style.contentinner}`}>
              {meetSanctionConfigurationState.isObjLoaded && meetSanctionConfigurationState.objData &&
                <ul style={{ paddingLeft: '10px' }}>
                  {meetSanctionConfigurationState.objData.attestationText
                    .split('+')
                    .filter(item => item.trim() !== '')
                    .map((item, idx) => (
                      <li key={idx} style={{ fontStyle: 'italic', color: '#6c6c6c' }}>
                        {item.trim()}
                      </li>
                    ))}
                </ul>
              }
            </div>
          </div>
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input
              label="Attestation Signature*"
              name="attestationSignature"
              value={formState.attestationSignature}
              error={errorState.attestationSignature}
              message={errorState.attestationSignature}
              onChange={(value) => { onFormValueChanged('attestationSignature', value); }} />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <PrimaryButton type="submit">Continue</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onCancelClicked}>Back</SecondaryButton>
          </div>
        </div>
        <PopUpModal
          widthPct={90}
          maxWidth={720}
          title="Facility Pool Depth Requirement Confirmation"
          displayPopUp={modalState.displayModal}
          onModalCanceled={onModalCancelClicked}>
          <div className="row">
            <div className="col-xs-12">
              <p><b>Facility Name:</b> {modalState.facilityName}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              Please confirm that minimum water depth for racing starts during practice and competition measured for a distance 3 feet 3-1/2 inches (1.0 meter) to 16 feet 5 inches (5.0 meters) from the end wall is at least 4 feet.
              <br />
              <p style={{ fontWeight: 'bold' }}>Selecting 'Pool Depth Requirement Met' will update the facility.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <YesNoSwitch
                label="Pool Depth Requirement Met?"
                name="depthRequirementMet"
                checked={formState.depthRequirementMet}
                error={errorState.depthRequirementMet}
                message={errorState.depthRequirementMet}
                onChange={(value) => { onFormValueChanged('depthRequirementMet', value); }}
              />
            </div>
          </div>
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12">
              The pool depth confirmation is not required if in-water starts will be used.
              <br />
              <YesNoSwitch
                label="In-Water Start?"
                name="isInWaterStart"
                checked={formState.isInWaterStart}
                error={errorState.isInWaterStart}
                message={errorState.isInWaterStart}
                onChange={(value) => { onFormValueChanged('isInWaterStart', value); }}
              />
            </div>
          </div>
          <div className="row usas-extra-top-margin">
            <div className="col-xs-12">
              <SecondaryButton type="button" onClick={onModalCancelClicked}>Continue</SecondaryButton>
            </div>
          </div>
        </PopUpModal>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={meetFileUploadState.isObjLoading} />
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={removeFileModalState.modalTitle}
        displayPopUp={removeFileModalState.displayPopUp}
        onModalCanceled={onRemoveFileModalCanceled}>
        <div className="row">
          <div className="col-xs-12">
            <p><b>File Type:</b> Meet Announcement</p>
            <p><b>Uploaded File Name:</b> {removeFileModalState.fileName}</p>
          </div>
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12">
            <PrimaryButton type="button" onClick={onRemoveTemplateClicked}>Yes, Remove</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onRemoveFileModalCanceled}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
    </Fragment>
  );
};

export default MeetSanctionInfoFormV2;